import { FlexBox, Icon, Page, Tabs, Text } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { mimChatbotsApi } from 'apis/chatbots';
import { appActions } from 'app/app.actions';
import { AppLink } from 'components/appLink';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppNavigate } from 'utils/url/useAppNavigate';
import { useAppPathParams } from 'utils/url/useAppPathParams';

import { ChatbotUpdateSourcesModal } from '../../components/chatbotUpdateSourcesModal/chatbotUpdateSourcesModal';

type MimChatbotTabs = 'identity' | 'sources';

const tabs = [
  { label: 'Chatbot identity', id: 'identity' },
  { label: 'Data sources', id: 'sources' },
];

export const MimChatbotView = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const navigate = useAppNavigate();
  const location = useLocation();

  const { id } = useAppPathParams('/settings/chatbots/mim/:id');

  const { chatbot } = mimChatbotsApi.useReadMimChatbotByIdQuery(
    { id },
    {
      refetchOnMountOrArgChange: true,
      selectFromResult: ({ data, ...rest }) => {
        return {
          ...rest,
          chatbot: data?.data,
        };
      },
    },
  );

  const handleTabChange = (tab: string) => {
    navigate({
      path: `/settings/chatbots/mim/:id/${tab as MimChatbotTabs}`,
      params: {
        path: {
          id: chatbot!.id,
        },
      },
    });
  };

  const selectedTab = location.pathname?.split('/').pop() ?? '';

  const handleSendFeedback = useCallback(() => {
    dispatch(
      appActions.showModal({
        modal: {
          type: 'app:feedbackForm',
          arg: {
            title: 'Chatbot Feedback',
            team: 'automation',
          },
        },
      }),
    );
  }, []);

  return (
    <>
      <Page>
        <Page.Head
          title={
            <FlexBox gap="200" alignItems="center">
              <AppLink
                path="/settings/chatbots/mim"
                style={{ color: 'inherit' }}
              >
                Mim Chatbots
              </AppLink>
              <Icon name="angle-right" />
              {chatbot?.name}

              <Text.ExternalLink onClick={handleSendFeedback} fontSize="200">
                Send feedback
              </Text.ExternalLink>
            </FlexBox>
          }
        />

        <Page.Tabs>
          <Tabs
            tabs={tabs}
            selectedId={selectedTab}
            onChange={handleTabChange}
          />
        </Page.Tabs>

        <Page.Body>
          <Outlet />
        </Page.Body>
      </Page>
      <ChatbotUpdateSourcesModal />
    </>
  );
};
